import React from "react";
import {
  Box, Typography, Button, Paper, Grid, CircularProgress, useTheme
} from "@mui/material";
import DocumentAutocompleteClone from "./DocumentAutocompleteClone";

const DocumentCardWrapper = ({ title, color, number, children }) => {
  const theme = useTheme();
  return (
    <Paper elevation={0} sx={{
      height: "100%", border: "1px solid", borderColor: theme.palette.divider,
      borderRadius: 3, bgcolor: "background.paper", p: 2.5, display: "flex", flexDirection: "column"
    }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Box sx={{
          width: 24, height: 24, borderRadius: "50%", bgcolor: color,
          display: "flex", alignItems: "center", justifyContent: "center", mr: 1.5,
          color: "white", fontSize: "0.75rem", fontWeight: 600
        }}>
          {number}
        </Box>
        <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1 }}>
          {title}
        </Typography>
      </Box>
      {children}
    </Paper>
  );
};

const CoincidenceTab = ({
  token,
  idDocument,
  nameDocument,
  targetId,
  setTargetId,
  targetName,
  setTargetName,
  loadingClone,
  onExecute,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={6}>
          <DocumentCardWrapper title="Origen" color="#3b82f6" number="1">
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {nameDocument}
            </Typography>
          </DocumentCardWrapper>
        </Grid>
        <Grid item xs={12} md={6}>
          <DocumentCardWrapper title="Destino" color="#10b981" number="2">
            <DocumentAutocompleteClone
              token={token}
              documentID={targetId}
              setDocumentID={setTargetId}
              setNameDocument={setTargetName}
              excludeId={idDocument}
            />
          </DocumentCardWrapper>
        </Grid>
      </Grid>

      <Button
        fullWidth
        onClick={onExecute}
        disabled={!targetId || loadingClone}
        sx={{
          py: 2,
          fontWeight: 700,
          fontSize: "0.95rem",
          letterSpacing: 0.5,
          borderRadius: "10px",
          transition: "all 0.2s ease",
          ...(targetId && !loadingClone
            ? {
                bgcolor: "primary.main",
                color: "#ffffff",
                boxShadow: "0 4px 14px rgba(59,130,246,0.4)",
                "&:hover": { bgcolor: "primary.dark", boxShadow: "0 6px 18px rgba(59,130,246,0.5)" },
              }
            : {
                "&.Mui-disabled": {
                  bgcolor: theme.palette.mode === "dark" ? "#2a2a2a" : "#e0e0e0",
                  color: theme.palette.mode === "dark" ? "#555" : "#9e9e9e",
                },
              }),
        }}
      >
        {loadingClone ? (
          <CircularProgress size={24} color="inherit" />
        ) : targetId ? (
          "Ejecutar Clonación Inteligente"
        ) : (
          "Selecciona un documento destino"
        )}
      </Button>
    </Box>
  );
};

export default CoincidenceTab;